import {
  AllGiftCardOfferCoupon,
  FidelityCardPointSimulationDto,
  FidelityCardTypeEnum,
} from '../../../services/fidelity/fidelity';
import { Customer } from '../../../services/kingfisher/customer';
import { DiscountTypeEnum } from '../../../enum/discount-type.enum';
import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';
import { InstallationElement } from '../../../models/configurators-2d/applications/kitchen/kitchen-configuration-price';
import { LiteOfferResult, MlData } from '../../../models/configurators-2d/tunnel/kitchen/kitchen-tunnel-store-model';
import { WorkbenchEan } from 'src/app/models/configurators-2d/applications/workbench/workbench-ean';
import { ComplementaryProduct } from '../../../models/configurators-2d/complementary-products/complementary-product';
import { PricedItem } from '../../../models/configurators-2d/tunnel/common-tunnel-dtos';

export class Price {
  baseAmount: number;
  actualAmount: number;

  constructor(data: { baseAmount: number; actualAmount: number }) {
    this.baseAmount = data.baseAmount;
    this.actualAmount = data.actualAmount;
  }

  get discountedAmount() {
    return this.baseAmount - this.actualAmount;
  }
}

export type KitchenExtraPricing = {
  totalWorkbench: Price;
  totalInstallation: Price;
  totalDelivery: Price;
  totalWorkbenchPlan: Price;
  HBMWorkbench: Price;
  kitchenWorkbenchConfigurations: WorkbenchEan[];
};

export type PricingState = {
  totalConception?: Price;
  detailConception?: Map<string, Price>;
  delivery?: Price;
  totalInstallation?: Price;
  totalWithoutFunding?: Price;
  totalWithFunding?: number;
  extraPricing?: unknown;
  delta?: Price;
  totalComplementaryProduct?: Price;
  fidelity?: FidelityCardPointSimulationDto[];
};

export type InstallationState = {
  more2Years?: boolean;
  withInstallation?: boolean;
  detailInstallation?: InstallationElement[];
};

export type Funding = {
  code?: string;
  mensuality?: number;
  duration?: number;
  interest?: number;
  offerTable?: LiteOfferResult[];
  mlData?: MlData;
  vac?: string;
  txtAssurance?: string;
  total?: number;
};
export type FundingState = {
  fundingWithInstallation?: Funding;
  fundingWithoutInstallation?: Funding;
  downPayment?: number;
};

export class Fidelity {
  typeCard: FidelityCardTypeEnum;
  cardNumber: string;
  points: number;
  coupons: AllGiftCardOfferCoupon;
  createdDate: Date;
  expiredDate?: Date;
  maxPoints: number;
  cardIsPaidButNotActiveYet: boolean;
}

export type CustomerState = {
  userData: Customer;
  fidelity: Fidelity;
};

export type ComplementaryProductState = {
  products: ComplementaryProduct[];
  total?: PricedItem;
  hasRemovedProducts?: boolean;
};

export type TunnelDataState = {
  mainContext: CONFIG_CONTEXT;
  currentPricing: PricingState;
  currentInstallation: InstallationState;
  currentFunding: FundingState;
  currentCustomer: CustomerState;
  currentDiscount: DiscountTypeEnum;
  currentComplementaryProduct: ComplementaryProductState;
  configurationData: Map<CONFIG_CONTEXT, unknown>;
  installationLoading: boolean;
  fundingLoading: boolean;
  fidelityLoading: boolean;
  pricingLoading: boolean;
  complementaryProductLoading: boolean;
};
